import styled from "styled-components";
import { StyledDocumentTitle } from "../styles/styledTextDocument";

export const StyledServiceDetailsWrapper = styled.div`
  .services-details-head {
    padding: 15px 0 25px;
    display: grid;
    align-items: center;
    grid-template-columns: repeat(auto-fill, minmax(160px, max-content) );
    grid-gap: 15px;

    button {
      height: 45px;
    }
  }

  .services-details__client-list-head {
    display: grid;
    align-items: center;
    grid-template-columns: max-content 175px;
    grid-gap: 20px;

    @media screen and (max-width: 768px) {
      grid-template-columns: 100%;
    }
  }
  
  .services-details__actions {
    padding: 0 0 20px;
    display: grid;
    grid-template-columns: repeat(2, max-content);
    grid-gap: 15px;
  }
`;

export const StyledConnectionList = styled.div`
  ${StyledDocumentTitle} {
    padding: 0 0 15px;
  }

  .connections {
    &__row {
      padding: 10px 0;
      display: grid;
      grid-template-columns: 1fr 40px;
      
      &:not(:last-child) {
        border-bottom: 1px solid ${({theme}) => theme.surface.border};
      }
    }
    
    &__project {
      color: ${({theme}) => theme.text.primary};
      font-weight: 600;
    }
    &__name {
      font-size: 14px;
    }
    
    &__client {
      color: ${({theme}) => theme.text.secondary};
      font-size: 12px;
    }
  }
  
  button {
    min-width: auto;
    width: 40px;
    padding: 0;
  }

  button[border="danger"] {
    color: ${({theme}) => theme.state.danger};
  }
`;

export const StyledBalanceList = styled.div`
  max-height: calc(100vh - 480px);
  overflow-y: auto;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 8px;
    background-color: ${({theme}) => theme.scrollbar.track};
    border-radius: 20px;
  }
  &::-webkit-scrollbar-track{
    background-color: ${({theme}) => theme.scrollbar.track};
    border-radius: 20px;
  }
  &::-webkit-scrollbar-thumb {
    width: 12px;
    border: 2px solid ${({theme}) => theme.scrollbar.track};
    background: ${({theme}) => theme.scrollbar.thumb};
    border-radius: 12px;
  }

  .balances {
    &__row {
      padding: 5px 0 5px 10px;
      display: grid;
      align-items: center;
      grid-template-columns: 1fr 40px;
      cursor: pointer;

      &:hover {
        color: ${({theme}) => theme.brand.primary};
        background-color: ${({theme}) => theme.surface.hover};
      }

      &:not(:last-child) {
        border-bottom: 1px solid ${({theme}) => theme.surface.border};
      }
    }

    &_active {
      background-color: ${({theme}) => theme.surface.selected};
    }
  }
`;

export const StyledDocumentWrapper = styled.div``;
